import React, { useState } from "react";
import "./login.css";
import { Form, Button, InputGroup, Modal, Container } from "react-bootstrap";
import { BsFillEyeFill, BsFillEyeSlashFill } from "react-icons/bs";
import { useAuth } from "../../contexts/AuthProvider";
import { switchTenant } from "../../config/tenants";
import Spinner from "react-bootstrap/Spinner";
import { useNavigate } from "react-router-dom";
import Pahtfind from '../../imgs/Pathfind.png'


const Login = () => {
  const { logins, tenant, tenants } = useAuth();
  const navigate = useNavigate();

  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const [buttonStyle, setButtonStyle] = useState({
    backgroundColor: "#00C6C1",
    borderColor: "#00C6C1"
  });

  const handleEmailChange = (event) => {
    setLogin(event.target.value);
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCloseErrorModal = () => {
    setShowErrorModal(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (login.trim() === "") {
      setEmailError("Por favor, preencha o campo de email");
      return;
    } else {
      setEmailError("");
    }

    if (password.trim() === "") {
      setPasswordError("Por favor, preencha o campo de senha");
      return;
    } else {
      setPasswordError("");
    }

    try {
      setLoading(true);
      const userData = await logins(login, password);
      navigate("/logs_pathfind");
    } catch (error) {
      console.error("Erro:", error);
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="mb-3 text-center">
          {<img src={Pahtfind} alt={Pahtfind} className="img-fluid" />}
        </div>
        <div className="card card-outline card-info">
          <div className="card-header">
            <h4 className="mb-0 text-center">
              <b>Login</b>
            </h4>
          </div>
          <div className="card-body login-card-body">
            <Form onSubmit={handleSubmit}>
              {tenants.length > 1 && (
                <Form.Group className="mb-3">
                  <Form.Label>Cliente</Form.Label>
                  <Form.Select
                    value={tenant ? tenant.slug : ""}
                    onChange={(e) => switchTenant(e.target.value, "/login")}
                  >
                    {!tenant && <option value="">Selecione o cliente</option>}
                    {tenants.map((t) => (
                      <option key={t.slug} value={t.slug}>
                        {t.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              )}
              {tenants.length === 1 && tenant && tenant.name && (
                <p className="text-center text-muted">Cliente: {tenant.name}</p>
              )}
              {tenants.length === 0 && (
                <div className="text-danger mb-3">Nenhum backend configurado.</div>
              )}
              <Form.Group className="mb-3">
                <Form.Label>E-mail</Form.Label>
                <Form.Control
                  type="email"
                  value={login}
                  onChange={handleEmailChange}
                />
                {emailError && <div className="text-danger">{emailError}</div>}
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Senha:</Form.Label>
                <InputGroup>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={handlePasswordChange}
                  />
                  <Button
                    variant="secondary"
                    onClick={togglePasswordVisibility}
                  >
                    {showPassword ? <BsFillEyeSlashFill /> : <BsFillEyeFill />}
                  </Button>
                </InputGroup>
                {passwordError && (
                  <div className="text-danger">{passwordError}</div>
                )}
              </Form.Group>
              <div className="text-center">
              <Button
                type="submit"
                className="w-25 text-dark"
                disabled={isLoading || !tenant}
                style={buttonStyle}
                onMouseEnter={() =>
                    setButtonStyle({
                      backgroundColor: "#008B8B", // Cor ao passar o mouse
                      borderColor: "#008B8B"
                    })
                  }
                  onMouseLeave={() =>
                    setButtonStyle({
                      backgroundColor: "#00C6C1", // Cor padrão
                      borderColor: "#00C6C1"
                    })
                  }
              >
                {isLoading ? (
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                ) : (
                  "Entrar"
                )}
              </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;